import { checkConditions } from '@btime/helpers'
import { useState, useEffect } from 'react'

const QUESTIONS_CAN_HAVE_LOGIC = ['calc', 'checkbox', 'float', 'multiple', 'numeric', 'place', 'select']

const useLogicReplies = (allReplies, localReply, question) => {
  const [shouldRenderReplies, setShouldRenderReplies] = useState([])
  const { questionType, questionReference } = question

  const childrenReplies = allReplies?.filter(reply => reply?.question?.parentReference === questionReference)
  const logicReplies = childrenReplies?.filter(item => checkConditions(localReply, item?.question?.displayConditions))

  useEffect(() => {
    if (QUESTIONS_CAN_HAVE_LOGIC.includes(questionType)) {
      if (!!logicReplies?.length) {
        setShouldRenderReplies(() =>
          logicReplies.map(reply => {
            return { ...reply, shouldRender: true }
          })
        )
      } else {
        setShouldRenderReplies([])
      }
    }
  }, [localReply?.value])

  return shouldRenderReplies
}

export default useLogicReplies
